import { api } from '@/f1/service';
import JsonViewer from 'vue-json-viewer'
import moment from 'moment-timezone';

//restful api
import { log } from '@/f1/service/api';

//i18n_data
import fields from './i18n_data'
import i18n_data from '@/component/i18n_data';

const default_opt = () => ({
  perPage: 10,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

export default {
  components : { JsonViewer },
  props : ['group_id'],
  data: () => ({ so : Object.assign({}, default_opt(), { opt : {} }) }),
  computed: {
    rowCount() { return this.so.totalRows || 0; },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return fields.i18n_fields[this.i18n]
    }
  },
  methods: {
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk || '',
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      // Build all
      // var search = { target : 'log.action', cmd : 'list.user', limit: so.pc, offset: (so.pg - 1) * so.pc, body: { and: [], or: [], sort: [] } }
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, body: { and: [], or: [], sort: [] } }
      // order
      if(so.ok) { search.body.sort.push({name: so.ok, op: so.od == 'd' && 'desc' }); }
      // group
      if(this.group_id) { search.body.and.push({ name: 'group_id', op: '=', value : this.group_id }); }
      // search
      if(so.sk && so.sv) {
        const value = so.sv.replace(/\*/g, '%');
        for(let key of so.sk.split(',')) {
          search.body.and.push({name: key, value: `%${value}%`, op: 'like' });
        }
      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        switch(key) {
          case 'created_at_sd' : search.body.and.push({name: 'created_at', value: moment(value).valueOf(), op: '>=' }); break;
          case 'created_at_ed' : search.body.and.push({name: 'created_at', value: moment(value).add(1, 'd').valueOf(), op: '<=' }); break;
          default: search.body.and.push({name: key, value: value.replace(/\*/g, '%'), op: /[%\*]/.test(value) ? 'like' : '=' }); break;
        }
      }

      try {
        // let rs = await api.member.Manager(search);
        let rs = await log.action.userList(search);
        this.so.totalRows = rs.total;

        if(!rs.body) { rs.body = [] }

        for (let i = 0; i < rs.body.length; i++) {
          try { rs.body[i].info = JSON.parse(rs.body[i].info) }
          catch(e) { console.log('info is not json') }
        }

        return rs.body;
      }
      catch(e) { this.$toastr.e(`${i18n_data._i18n_error.load_failed[this.i18n]}` || e.data); }
    },
    detail(item) {
      this.$router.push(`/site/${item.id}`); },
  },
  created() { console.log('[vue] log.action', 'created'); },
  destroyed() { console.log('[vue] log.action', 'destroyed'); },
  mounted() { console.log('[vue] log.action', 'mounted'); },
}
